import React from "react";
import style from "../style.module.scss";
import { useTranslation } from "react-i18next";

export interface Props {
    thumbnail: string;
    dataTestId?: string;
}

export const PreloaderLayout = (props: Props) => {
    const { thumbnail, dataTestId = "VideoPreloaderLayout" } = props;
    const { t } = useTranslation();

    return (
        <div
            className={
                "vjs-big-play-centered vjs-fluid video-js vjs-paused vjs-controls-enabled vjs-workinghover vjs-v8 vjs-user-inactive vjs_video_7310-dimensions vjs-waiting"
            }
            style={{ height: "100%" }}
        >
            <img src={thumbnail} className={style.posterImage} height="auto" width="100%" alt="Brightcove" />
            <div className={style.playButton}>
                <button
                    className={"vjs-big-play-button"}
                    type="button"
                    title={t("Play", { ns: "common" })}
                    aria-disabled="false"
                    data-test-id={dataTestId}
                >
                    <span className="vjs-icon-placeholder" aria-hidden="true"></span>
                    <span className="vjs-control-text" aria-live="polite">
                        {t("Play", { ns: "common" })}
                    </span>
                </button>
            </div>
        </div>
    );
};
